<template>
  <div class="content-wrapper">
    <ContentHeader title="Топливные карт" />
    <div class="content-body">
      <card
        headerTitle="УПРАВЛЕНИЕ ТОПЛИВНОЙ КАРТОЙ"
        :busy="isCardsLoading"
        @reload="reloadCards"
      >
        <template slot="block">
          <form>
            <div class="bg-prim-grey">
              <p style="padding: 10px">
                Номер карты:
                <strong>{{ thisCard.id }}</strong>
              </p>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="holderNameInput">Карт-счёт :</label>
                  <select class="form-control" :value="thisCard.account_id">
                    <option v-for="ca in getCardsAccsNotRemoved" :key="ca.id" :value="ca.id">
                      {{ ca.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-10">
                <div class="form-group">
                  <label for="holderNameInput">Держатель :</label>
                  <input
                    type="text"
                    id="holderNameInput"
                    class="form-control"
                    placeholder="Имя и фамилия"
                    name="holder_name"
                    :value="thisCard.holder_name"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div style="margin-top: 31px; margin-bottom: 24px">
                  <button
                    type="button"
                    v-if="thisCard.block"
                    class="btn btn-info btn-block"
                    disabled
                  >
                    <i class="icon-lock4"></i> Карта заблокирована
                  </button>
                  <button
                    type="button"
                    v-else
                    class="btn btn-info btn-block"
                    @click="showBlockModal = true"
                  >
                    <i class="icon-lock4"></i> Заблокировать карту
                  </button>
                </div>
              </div>
            </div>
            <h4 class="form-section">Топливные лимиты / управление</h4>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="dayFuelInput">Суточный лимит, л:</label>
                  <input
                    type="text"
                    id="dayFuelInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.volume_limit.target_values.day"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="weekFuelInput">Недельный лимит, л:</label>
                  <input
                    type="text"
                    id="weekFuelInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.volume_limit.target_values.week"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="monthFuelInput">Месячный лимит, л:</label>
                  <input
                    type="text"
                    id="monthFuelInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.volume_limit.target_values.month"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="confirmFuelInput">Лимит операций в сутки:</label>
                  <input
                    type="text"
                    id="confirmFuelInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.volume_limit.target_values.confirm"
                  />
                </div>
              </div>
            </div>
            <h4 class="form-section">Денежные лимиты / управление</h4>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="dayMoneyInput">Суточный лимит, тенге:</label>
                  <input
                    type="text"
                    id="dayMoneyInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.money_limit.target_values.day"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="weekMoneyInput">Недельный лимит, тенге:</label>
                  <input
                    type="text"
                    id="weekMoneyInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.money_limit.target_values.week"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="monthMoneyInput">Месячный лимит, тенге:</label>
                  <input
                    type="text"
                    id="monthMoneyInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.money_limit.target_values.month"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="confirmMoneyInput">Лимит операций в сутки:</label>
                  <input
                    type="text"
                    id="confirmMoneyInput"
                    class="form-control"
                    placeholder="0"
                    :value="thisCard.money_limit.target_values.confirm"
                  />
                </div>
              </div>
            </div>
            <h4 class="form-section">Пин-код / управление</h4>
            <div
              v-if="showPinCompareError"
              class="alert alert-danger"
              role="alert"
            >
              <span>Пин-коды не совпадают!</span>
              <a class="float-xs-right" @click="showPinCompareError = false"
                >X</a
              >
            </div>
            <div
              v-if="showPinLengthError"
              class="alert alert-danger"
              role="alert"
            >
              <span>Пин-код должен состоять из 4 цифр!</span>
              <a class="float-xs-right" @click="showPinLengthError = false"
                >X</a
              >
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="pinInput">Пин-код</label>
                  <input
                    type="password"
                    id="pinInput"
                    class="form-control"
                    placeholder="****"
                    name="pin"
                    pattern="[0-9]4"
                    inputmode="numeric"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="pinInput2">Подтвеждение пин-кода</label>
                  <input
                    type="password"
                    id="pinInput2"
                    class="form-control"
                    placeholder="****"
                  />
                </div>
              </div>
            </div>
          </form>
        </template>
        <template slot="footer">
          <button
            type="submit"
            class="btn btn-success btn-min-width"
            style="margin-right: 14px"
            @click="updateCard"
          >
            <i class="icon-save"></i> Сохранить
          </button>
          <router-link to="/cards" class="btn btn-secondary btn-min-width">
            <i class="icon-arrow-left2"></i> Вернуться в раздел
          </router-link>
        </template>
      </card>
      <modal
        v-if="showBlockModal"
        @close="closeBlockModal"
        @cancel="closeBlockModal"
        @ok="blockCard"
      >
        <template slot="header-title">Подтвеждение</template>
        <template slot="body">
          <p>Нажимая ОК Вы подтверждаете блокировку топливной карты.</p>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import card from "@/components/card.vue";
import modal from "@/components/modal.vue";
import { mapGetters } from "vuex";
import {
  CARDS_REQUEST,
  CARDS_UPDATE_REQUEST,
  CARDS_BLOCK_REQUEST,
} from "@/store/actions/cards";

export default {
  name: "CardEdit",
  components: {
    ContentHeader,
    card,
    modal,
  },
  data() {
    return {
      showBlockModal: false,
      showPinCompareError: false,
      showPinLengthError: false,
    };
  },
  computed: {
    ...mapGetters([
      "getCards",
      "getCardById",
      "isCardsLoading",
      "getCardsAccsNotRemoved",
    ]),
    thisCard() {
      return (
        this.getCardById(this.$route.params.id) || {
          money_limit: {
            target_values: {
              day: null,
              week: null,
              month: null,
              confirm: null,
            },
          },
          volume_limit: {
            target_values: {
              day: null,
              week: null,
              month: null,
              confirm: null,
            },
          },
        }
      );
    },
  },
  methods: {
    closeBlockModal() {
      this.showBlockModal = false;
    },
    updateCard() {
      this.showPinCompareError = false;
      this.showPinLengthError = false;

      let pin = document.getElementById("pinInput").value;
      if (isNaN(Number(pin)) || (pin.length > 0 && pin.length != 4)) {
        this.showPinLengthError = true;
        return;
      }
      if (pin !== document.getElementById("pinInput2").value) {
        this.showPinCompareError = true;
        return;
      }
      let body = {
        holder_name: document.getElementById("holderNameInput").value || null,
        pin: pin || null,
        money_limit: {
          target_values: {
            day: document.getElementById("dayMoneyInput").value || null,
            week: document.getElementById("weekMoneyInput").value || null,
            month: document.getElementById("monthMoneyInput").value || null,
            confirm: document.getElementById("confirmMoneyInput").value || null,
          },
        },
        volume_limit: {
          target_values: {
            day: document.getElementById("dayFuelInput").value || null,
            week: document.getElementById("weekFuelInput").value || null,
            month: document.getElementById("monthFuelInput").value || null,
            confirm: document.getElementById("confirmFuelInput").value || null,
          },
        },
      };
      console.log(JSON.stringify(body));
      this.$store
        .dispatch(CARDS_UPDATE_REQUEST, {
          card_id: this.thisCard.id,
          body: JSON.stringify(body),
        })
        .then(() => {
          document.getElementById("pinInput").value = "";
          document.getElementById("pinInput2").value = "";
        })
        .catch((err) => {
          if (err.response.data.error === "invalid pin")
            this.showPinLengthError = true;
        });
    },
    blockCard() {
      this.$store
        .dispatch(CARDS_BLOCK_REQUEST, { card_id: this.thisCard.id })
        .then(() => {
          this.closeBlockModal();
        });
    },
    reloadCards() {
      this.$store.dispatch(CARDS_REQUEST);
    },
  },
  created() {
    if (!this.cardsOnceLoaded) this.$store.dispatch(CARDS_REQUEST);
  },
};
</script>